import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-product-stock',
  templateUrl: './product-stock.component.html',
  styleUrls: ['./product-stock.component.css']
})
export class ProductStockComponent implements OnInit {

  constructor(private AdviceService:ServiceService,private route: ActivatedRoute, private router: Router) { }
output:any=[];
loaderShown=true;
tableShown=false;
count=0;
New_count=0
next_output:any=[];
//------function for routing to view details-----------
ViewDetails(Id:any){
  localStorage.setItem('stock_id',Id)
  this.router.navigateByUrl(('admin/stock-detail'));
}
//---function for click previous----------
clicks_previous(){
  if(this.New_count==0){
    return;
  }
  else{
    this.New_count=this.New_count-1;
    this.count=this.New_count; 
  }
  this.AdviceService.ListStock(this.count).subscribe((res)=>{
    this.output=res.data
  })

}
//-------function for click next-------
clicks_next(){
  this.count=this.count+1
  this.AdviceService.ListStock(this.count).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })
}
//-------date formating-------------
  
today: Date = new Date();
pipe = new DatePipe('en-US');
todayWithPipe:any= null;

DateFormat(value:any){
  //-------date formating----------------------
  this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
  return this.todayWithPipe
}
  ngOnInit(): void {
    this.AdviceService.ListStock(this.count).subscribe((res)=>{
      this.output=res.data
      this.loaderShown=false;
      this.tableShown=true;
  
      })
  }

}
